<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="p-breadcrumb">
        <ul class="p-breadcrumb-list">
          <li class="p-breadcrumb-list__item">
            <a href="/coins-admin/cart/result-list">カートプッシュの成果一覧</a>
          </li>
          <li class="p-breadcrumb-list__item">{{ summaryDate }}</li>
        </ul>
      </div>
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">カートプッシュの成果</div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div class="p-message-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">カートプッシュの成果が存在しません</div>
            </div>
            <table class="c-table cart-result">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">集計日</span>
                    <sort-switch name="summaryDate" :order="sortTargets.summaryDate" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">プッシュ名</span>
                    <sort-switch name="messageName" :order="sortTargets.messageName" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">表示数</span>
                    <sort-switch name="displayCount" :order="sortTargets.displayCount" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <sort-switch name="clickCount" :order="sortTargets.clickCount" @on-click="onClickSortButton($event)" />
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">CTR</span>
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">配信開始日時</span>
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">配信終了日時</span>
                  </th>
                </tr>
              </thead>

              <!-- カート成果リスト -->
              <cart-message-result-list-item
                v-for="(summaryMessage,index) in summaryMessages.data"
                :key="index"
                :summary-message="summaryMessage"
                @show-click="onShowMessage"
              />
              <!-- カート成果リスト -->
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import '../molecules/Datepicker.vue';
/**
 * カートプッシュの成果メッセージ一覧ページ
 *
 * 仕様変更 (2025-10-06):
 * - 以前は periodType プロパティを受け取り、APIリクエストに period_type パラメータを含めていた
 * - 仕様変更により periodType を廃止
 * - 常に summary_message_daily テーブルを使用
 */
const ja = 'ja';
import axios from 'axios';

export default {
  components: {

  },
  props: {
    summaryInfo: Object,
    summaryDate: String,
    // 仕様変更: periodType プロパティを廃止
  },
  data () {
    return {
      summaryMessages: [],

      ja:ja,
      sortTargets: {
        summaryDate: -1,
        messageName: 0,
        displayCount: 0,
        clickCount: 0,
      },
      currentSortTarget: null,
      currentSortOrder: null,

      // フラグ系
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      isSearchCondition: false,

      paginationInfo: null,
      page: 1,
      cr: "\n",
    }
  },
  mounted: function() {
    import('../../funcs/pages/message').then(module => {
      module.Message();
      this.loadData();
    });
  },
  methods: {
    loadData: function() {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメーター作成
      const params = {
        params: {
          summary_date: this.summaryDate,
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      };

      this.isLoading = true;
      this.isLoaded = false;

      // 配信状況データの取得処理実行
      axios.get('/api/analysis/summary/cart-message',params)
        .then(res => {
          this.summaryMessages = res.data.items;
          this.paginationInfo = res.data.items;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            if (res.data.items.data.length < 1) this.isEmpty = true;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = 'カート成果一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: メッセージリストのソートボタンクリック
    onClickSortButton: function(target) {
      //event.preventDefault();
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 配信メッセージの編集ボタン
    onShowMessage: function(summaryMessage) {
      let url = this.summaryInfo.messageUrl + '/' + summaryMessage.message_id + '/' + summaryMessage.summary_date;
      location.href = url;
    },

    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteMessage = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // ページネーションボタンクリック処理
    // ページネーションコンポーネントからキックされる
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData();
    },
  }
}
</script>
